import * as Yup from "yup";
import { LanguageTranslation } from "../../components/language-translation/LanguageTranslation";

export const postValidationSchema = (langId: string) =>
  Yup.object({
    title: Yup.string()
      .trim()
      .max(
        255,
        LanguageTranslation({
          labelName: "max_255_chars",
          languageCode: langId,
        }) || "Maximum 255 characters allowed"
      )
      .required(
        LanguageTranslation({
          labelName: "title_required",
          languageCode: langId,
        }) || "Title is required"
      ),

    width: Yup.number()
      .required(
        LanguageTranslation({
          labelName: "width_required",
          languageCode: langId,
        }) || "Width is required"
      )
      .min(
        1,
        LanguageTranslation({
          labelName: "min_width_1",
          languageCode: langId,
        }) || "Width must be at least 1"
      )
      .max(
        10000,
        LanguageTranslation({
          labelName: "max_width_10000",
          languageCode: langId,
        }) || "Width is too large"
      ),

    height: Yup.number()
      .required(
        LanguageTranslation({
          labelName: "height_required",
          languageCode: langId,
        }) || "Height is required"
      )
      .min(
        1,
        LanguageTranslation({
          labelName: "min_height_1",
          languageCode: langId,
        }) || "Height must be at least 1"
      )
      .max(
        10000,
        LanguageTranslation({
          labelName: "max_height_10000",
          languageCode: langId,
        }) || "Height is too large"
      ),

    depth: Yup.number()
      .required(
        LanguageTranslation({
          labelName: "depth_required",
          languageCode: langId,
        }) || "Depth is required"
      )
      .positive(
        LanguageTranslation({
          labelName: "depth_positive",
          languageCode: langId,
        }) || "Depth must be positive"
      )
      .max(
        10000,
        LanguageTranslation({
          labelName: "max_depth_10000",
          languageCode: langId,
        }) || "Depth is too large"
      ),

    weight: Yup.number()
      .required(
        LanguageTranslation({
          labelName: "weight_required",
          languageCode: langId,
        }) || "Weight is required"
      )
      // .min(1, LanguageTranslation({ labelName: "min_weight_1", languageCode: langId }) || "Weight must be at least 1")
      .max(
        70,
        LanguageTranslation({
          labelName: "max_weight_70",
          languageCode: langId,
        }) || "Weight must be less than or equal to 70kg"
      ),

    price: Yup.number()
      .required(
        LanguageTranslation({
          labelName: "price_required",
          languageCode: langId,
        }) || "Price is required"
      )
      .min(
        1,
        LanguageTranslation({
          labelName: "min_price_1",
          languageCode: langId,
        }) || "Price must be at least 1"
      )
      .max(
        1000000,
        LanguageTranslation({
          labelName: "max_price_1000000",
          languageCode: langId,
        }) || "Price is too large"
      ),

    quantity: Yup.number()
      .required(
        LanguageTranslation({
          labelName: "web_quantity_required",
          languageCode: langId,
        }) || "Quantity is required"
      )
      .min(
        1,
        LanguageTranslation({
          labelName: "min_quantity_1",
          languageCode: langId,
        }) || "Quantity must be at least 1"
      )
      .max(
        10000,
        LanguageTranslation({
          labelName: "max_quantity_10000",
          languageCode: langId,
        }) || "Quantity is too large"
      ),

    category: Yup.string()
      .trim()
      .max(
        255,
        LanguageTranslation({
          labelName: "max_255_chars",
          languageCode: langId,
        }) || "Maximum 255 characters allowed"
      )
      .required(
        LanguageTranslation({
          labelName: "category_required",
          languageCode: langId,
        }) || "Category is required"
      ),

    artTag: Yup.object({
      id: Yup.number().required(
        LanguageTranslation({
          labelName: "arttag_id_required",
          languageCode: langId,
        }) || "Art tag ID is required"
      ),
      name: Yup.string()
        .trim()
        .max(
          255,
          LanguageTranslation({
            labelName: "max_255_chars",
            languageCode: langId,
          }) || "Maximum 255 characters allowed"
        )
        .required(
          LanguageTranslation({
            labelName: "arttag_name_required",
            languageCode: langId,
          }) || "Art tag name is required"
        ),
    }).required(
      LanguageTranslation({
        labelName: "arttag_required",
        languageCode: langId,
      }) || "Art tag is required"
    ),

    mainColor: Yup.object()
      .shape({
        name: Yup.string()
          .trim()
          .max(
            255,
            LanguageTranslation({
              labelName: "max_255_chars",
              languageCode: langId,
            })
          ),
        hexcode: Yup.string(),
      })
      .nullable(),

    secondaryColor: Yup.object()
      .shape({
        name: Yup.string()
          .trim()
          .max(
            255,
            LanguageTranslation({
              labelName: "max_255_chars",
              languageCode: langId,
            })
          ),
        hexcode: Yup.string(),
      })
      .nullable(),
  }).test(
    "at-least-one-color",
    LanguageTranslation({
      labelName: "at_least_one_color_required",
      languageCode: langId,
    }) || "Either main color or secondary color is required",
    function (values) {
      if (values.mainColor?.hexcode || values.secondaryColor?.hexcode)
        return true;
      return this.createError({
        path: "mainColor",
        message:
          LanguageTranslation({
            labelName: "at_least_one_color_required",
            languageCode: langId,
          }) || "Either main color or secondary color is required",
      });
    }
  );
export const reelValidationSchema = (langId: string) =>
  Yup.object({
    description: Yup.string()
      .trim()
      .max(
        500,
        LanguageTranslation({
          labelName: "max_2200_chars",
          languageCode: langId,
        }) || "Maximum 500 characters allowed"
      ),
  });
